import { parseDocumentFromString } from 'anodum';
import hdrm from '../../hdrm';
import site from '../../site';
import globals from '../../globals';
import blocks from '../../blocks';
import getLiveDocument from '../accessors/get-live-document';
import actionTypes from '../constants/action-types';
import blockTemplates from '../../block-templates';
import { UPDATE_STATIC_ONLY, UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';
import getUsedBlockTemplatesIdsFromElement from '../../block-templates/accessors/get-used-block-templates-ids-from-element';

const handleReplaceElement = (store, action) => {
  const { element, targetElementId, options } = action.payload;
  const { strategy } = options;
  const liveDocument = getLiveDocument();
  const isViewReloadRequired = strategy === UPDATE_STATIC_ONLY;
  const blockToAdd = blocks.accessors.getBlockByElement(element);

  let usedBlockTemplatesBeforeReplace;
  let usedBlockTemplatesAfterReplace;

  const staticDocument = hdrm.accessors.getStaticDocument();

  if (blockToAdd && !isViewReloadRequired) {
    usedBlockTemplatesBeforeReplace = getUsedBlockTemplatesIdsFromElement(staticDocument);
  }

  const newHTML = hdrm.operations.replaceElement(element, targetElementId, strategy);

  if (blockToAdd && !isViewReloadRequired) {
    const newDocumentMarkup = parseDocumentFromString(newHTML);
    usedBlockTemplatesAfterReplace = getUsedBlockTemplatesIdsFromElement(newDocumentMarkup);

    usedBlockTemplatesAfterReplace.forEach((blockTemplateId) => {
      if (!usedBlockTemplatesBeforeReplace.includes(blockTemplateId)) {
        blockTemplates.helpers.injectDependencies(liveDocument, blockTemplateId);
      }
    });
  }

  return newHTML;
};

const replaceElement = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.REPLACE_ELEMENT
      );

      actions.forEach((targetAction) => {
        handleReplaceElement(store, targetAction);
      });

      next(action);
      break;
    }

    case actionTypes.REPLACE_ELEMENT: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;
      const newHTML = handleReplaceElement(store, action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default replaceElement;
